import { RightButton } from 'components/order/request-awb/RightButton'
import { useDispatch, useSelector } from 'react-redux'
import { useFetch } from 'services/useFetch'
import { API_REQUEST_AWB } from 'services/apiRequestAWB'
import { setConfirmationMessage, setModal } from 'reducers/listReducer'
import { useState } from 'react'

export const RightButtonContainer = ({
    query,
    setTypeButton,
    isResetSelectedItem,
    setIsResetSelectedItem,
    setShowAlert,
    fetchList,
}) => {
    const dispatch = useDispatch()
    const [previewDetail, setPreviewDetail] = useState([])
    const { fetching: previewPrintLabel, isLoading: isLoadingPreview } = useFetch(API_REQUEST_AWB.PREVIEW_PRINT_LABEL)
    const { fetching: bulkPrintLabel, isLoading: isLoadingBulkPrintLabel } = useFetch(API_REQUEST_AWB.BULK_PRINT_LABEL)
    const { selectedValue, modal } = useSelector((state) => state.listReducer)

    const onClickRightButton = (type, message) => {
        if (query?.tab === 'request awb') {
            setTypeButton(type)
            dispatch(setModal({ confirm: true }))
            dispatch(setConfirmationMessage(message))
        } else {
            const payload = { order_ids: selectedValue?.selectedIds?.map((item) => item?.id) }
            previewPrintLabel(payload).then((response) => {
                setPreviewDetail(response?.data)
                dispatch(setModal({ printLabel: true }))
            })
        }
    }

    const printLabelHandler = () => {
        const payload = { order_ids: selectedValue?.selectedIds?.map((item) => item?.id) }
        bulkPrintLabel(payload).then(() => {
            setIsResetSelectedItem(!isResetSelectedItem)
            setShowAlert('Move to Packing Successfully', { printLabel: false })
            fetchList()
        })
    }

    const isSelectAWBError = () => {
        return (
            selectedValue?.selectedIds?.length &&
            selectedValue?.selectedIds?.every((item) => item?.is_request_failed === true)
        )
    }

    const props = {
        query,
        isSelectAWBError,
        onClickRightButton,
        selectedValue,
        isLoadingPreview,
        modal,
        onHide: () => dispatch(setModal({ printLabel: false })),
        printLabelHandler,
        isLoadingBulkPrintLabel,
        previewDetail,
    }

    return <RightButton {...props} />
}
